/**
 * iOS keyboard + visual-viewport helpers for the chat panel.
 *
 * Safari keeps `100vh` / `100dvh` at the layout size when the software
 * keyboard opens. The panel has to follow `visualViewport` instead, or the
 * header and composer sit under the keyboard.
 */

export const COMPACT_BREAKPOINT_PX = 480;
export const KEYBOARD_THRESHOLD_PX = 80;

export interface ViewportBox {
    top: number;
    left: number;
    width: number;
    height: number;
}

export function isCompactLayout(width: number): boolean {
    return width <= COMPACT_BREAKPOINT_PX;
}

export function isKeyboardOpen(
    layoutHeight: number,
    visualHeight: number,
    threshold = KEYBOARD_THRESHOLD_PX
): boolean {
    return layoutHeight - visualHeight > threshold;
}

export function visualViewportBox(
    visual:
        | Pick<VisualViewport, 'offsetTop' | 'offsetLeft' | 'width' | 'height'>
        | null
        | undefined,
    fallback: { innerWidth: number; innerHeight: number }
): ViewportBox {
    if (visual === undefined || visual === null) {
        return {
            top: 0,
            left: 0,
            width: fallback.innerWidth,
            height: fallback.innerHeight
        };
    }
    return {
        top: visual.offsetTop,
        left: visual.offsetLeft,
        width: visual.width,
        height: visual.height
    };
}
